import { GenericItemListTranslations } from './generic-item-list-translations.interface';

export const DEFAULT_GENERIC_ITEM_LIST_TRANSLATIONS: GenericItemListTranslations = {
  labels: {
    groupLabel: 'Item list',
    emptyList: 'No items defined.',
    itemLabel: 'Item',
    itemEntry: 'Item {index} of {total}',
  },
  buttons: {
    appendItem: 'Append item',
    appendItemLabel: 'Append item',
    removeItem: 'Remove item {index}',
  },
};
